module.exports = __webpack_public_path__ + "static/media/female.532f90ac.gif";